import { pick } from 'ramda';

import { getCleanUrl } from 'js/utils/url.util';
import { useUserSelector } from 'js/store/hooks';
import { useDynamicTags } from 'js/app/hooks/useDynamicTags';
import { DYNAMIC_TAG_NAMES } from '@interlayer/js/app/utils/constants';
import { useIsUserVerified } from 'js/app/hooks/user/hooks/useIsUserVerified';

import { JUMIO_STEPS } from '../components/JumioPopupUploader/constants';

export const useHideJumioPopup = () => {
    const isUserVerified = useIsUserVerified();
    const {
        isLoggedIn, skipIDVerificationOnLogin, jumioState, jumioStep
    } = useUserSelector(pick(['isLoggedIn', 'skipIDVerificationOnLogin', 'jumioState', 'jumioStep']));
    const [dtagJumioUploadPageUrl] = useDynamicTags([DYNAMIC_TAG_NAMES.jumioUploadPageUrl]);
    const isGracePeriod = jumioState === 'gracePeriod';
    const isLastJumioStep = [JUMIO_STEPS.loading, JUMIO_STEPS.passed].includes(jumioStep);
    const isUserHasGracePeriod = isGracePeriod ? false : isUserVerified && !isLastJumioStep;

    return !isLoggedIn || isUserHasGracePeriod || skipIDVerificationOnLogin || getCleanUrl() === dtagJumioUploadPageUrl;
};
